<!-- Postpone an open activity (E4 RF-24 to RF-27). Hyper modal markup inside MatDialog; Remix icons only. -->
<div class="modal-header">
  <h4 class="modal-title">
    <i class="ri-calendar-schedule-line me-1"></i>
    {{ 'task.postpone.title' | translate }}
  </h4>
  <button type="button" class="btn-close" (click)="close()" [attr.aria-label]="'task.postpone.cancel' | translate"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-1">{{ 'task.postpone.subtitle' | translate: { task: taskTitle } }}</p>
  @if (task?.deadlineAt) {
    <p class="font-13 mb-3">
      <i class="ri-time-line me-1 text-muted"></i>
      {{ 'task.postpone.current' | translate: { moment: (task.deadlineAt | timezoneDate: currentFormat : getTimezoneCompanyCurrentUser()) } }}
      @if (task?.untimed) {
        <span class="text-muted">· {{ 'task.moment.untimed' | translate }}</span>
      }
    </p>
  }

  <form [formGroup]="form">
    <div class="mb-3">
      <label class="form-label d-block">{{ 'task.postpone.moment' | translate }}</label>
      <app-schedule-moment-field formControlName="moment" [allowUntimed]="true" [minDate]="minDate" idPrefix="postponeMoment" />
    </div>

    <div class="mb-3">
      <label class="form-label" for="postponeReason">{{ 'task.postpone.reason' | translate }}</label>
      <textarea id="postponeReason" class="form-control" rows="2" formControlName="reason"></textarea>
      @if (showReasonError) {
        <span class="help-block text-danger"><small>{{ 'task.postpone.reasonRequired' | translate }}</small></span>
      }
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()" [disabled]="saving">
    {{ 'task.postpone.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="saving">
    @if (saving) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
    }
    {{ 'task.postpone.confirm' | translate }}
  </button>
</div>
